<template>
  <div class="notification">
    <notify-panel :type="1" :notify="systemMsg" />
    <notify-panel :type="2" :notify="remindMsg" />
  </div>
</template>

<script>
import NotifyPanel from './components/NotifyPanel'
import { notifyNew } from '@/api/notify'

export default {
  name: 'Notification',
  components: {
    NotifyPanel
  },
  data () {
    return {
      systemMsg: {},
      remindMsg: {}
    }
  },
  created () {
    this.getSystemMsg()
    this.getRemindMsg()
  },
  methods: {
    async getSystemMsg () {
      const response = await notifyNew({ notify_type: 3, is_system: 1 })
      this.systemMsg = response.data
    },
    async getRemindMsg () {
      const response = await notifyNew({ notify_type: 2 })
      this.remindMsg = response.data
    }
  }
}
</script>

<style scoped lang="scss">
</style>
